var React = require('react');

function FooterCurve (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M 0 10 L 0 20 L 800 20 L 800 10   Q 700  0 600 10   Q 500  20 400  0   Q 300  20 200 10   Q 100  0 0 10   Z"})));
}

FooterCurve.defaultProps = {"preserveAspectRatio":"none","viewBox":"0 0 800 20"};

module.exports = FooterCurve;

FooterCurve.default = FooterCurve;
